<!-- Roll in modal -->
<div id="rollinrolloutmodal">
<div
  class="modal-content shadow-none border-0"
  *ngIf="text=== 'Add and Save'"
  (keyup.enter)="bsModalRef.hide()"
  tabindex="1"
>
  <div class="modal-header d-block text-right">
    <div class="dismiss" (click)="bsModalRef.hide()" aria-label="Close">
      <a class="gb-icon-button text-decoration-none p-0" tabindex="0"
      (click)="trackingService.fireProp10Tracking('shop:update plan:you just saved modal:button:close','','','close','close' ,true)">
        <span aria-hidden="true" class="icon-ui-close"></span>
      </a>
    </div>
  </div>
  <div class="modal-title gb-body1 heavy mb-4" id="exampleModalLabel">
    You just saved with the {{product.code}} plan!
  </div>
  <div class="modal-body mb-7">
    <p class="gb-body2">{{product.offer?.savingsCopy}}</p>
    <div class="modal-footer">
      <button
        class="col-12 float-left p-1 firstlet-cap gb-primary-button"
        aria-label="Switch plan "
        data-dismiss="modal"
        aria-label="Close"
        (click)="trackingService.fireProp10Tracking('shop:update plan:you just saved modal:button:got it','','','got it','got it' ,true); bsModalRef.hide()"
      >
        {{getCopy('copy.rollIn.primaryButton')}}
      </button>
    </div>
  </div>
</div>

<!-- Roll out modal -->
<div
  class="modal-content shadow-none border-0"
  *ngIf="text=== 'Remove'"
  (keyup.enter)="bsModalRef.hide()"
  tabindex="1"
>
  <div class="modal-header d-block text-right">
    <div class="dismiss" (click)="bsModalRef.hide()" aria-label="Close">
      <a class="gb-icon-button text-decoration-none p-0" tabindex="0"
      (click)="trackingService.fireProp10Tracking('shop:update plan: no longer elligible for discount modal:button:close','','','close','close' ,true)">
        <span aria-hidden="true" class="icon-ui-close"></span>
      </a>
    </div>
  </div>
  <div class="modal-title gb-body1 heavy mb-4" id="exampleModalLabel">
    You are no longer eligible for {{product.code}} plan discount.
  </div>

  <div class="modal-body mb-8">
    <p class="gb-body2" *ngFor="let feature of selected; let fi = index">
      {{getCopy('plan.updated')}} {{feature.name }} {{getCopy('plan.price')}}
      <span class="gb-body1 font-weight-bold"
        >{{feature.price.customerFinalPrice | currency}}</span
      >
    </p>

    <div class="modal-footer">
      <button
        class="col-12 float-left p-1 firstlet-cap gb-primary-button"
        aria-label="Switch plan "
        data-dismiss="modal"
        aria-label="Close"
        (click)=" trackingService.fireProp10Tracking('shop:update plan: no longer elligible for discount modal:button:got it','','','got it','got it' ,true); bsModalRef.hide()"
      >
        {{getCopy('copy.rollOut.primaryButton')}}
      </button>
    </div>
  </div>
</div>
</div>